<template>
  <div class="dashboard">
    <page-views-item
      v-for="item in insightItems"
      :key="item.name"
      :title="item.title"
      :description="item.description"
      :chartData="item.data"
      :stacked="item.stacked"
      :showLegend="item.showLegend"
      :type="item.type"
      class="metric-item" 
    />
  </div>
</template>

<script>
import PageViewsItem from './metrics/PageViewsItem';
import { getPageViewsByGenderData, getDataForLabels } from './randomDataUtils';

const countryLabels = ['Canada', 'New Zealand', 'South Africa', 'USA'];
const cityLabels = ['Montreal, Canada', 'Auckland, NZ', 'Pretoria, RSA', 'Austin, Texas, USA'];
const deviceLabels = ['Mobile Device', 'Computer', 'Smart TV'];

export default {
  name: 'PageViewsDashboard',

  components: {
    PageViewsItem,
  },

  data: () => ({
    insightItems: [
      {
        name: 'gender',
        title: 'Page views by gender',
        description:
          'The number of people logged in to Facebook who have viewed your Page profile, broken down by gender group.',
        stacked: true,
        showLegend: true,
        data: getPageViewsByGenderData(),
      },
      {
        name: 'city',
        title: 'Page views by city',
        description:
          'The number of people logged in to Facebook who have viewed your Page profile, broken down by city.',
        type: 'horizontal-bar',
        data: getDataForLabels(cityLabels, 1, 6),
      },
      {
        name: 'country',
        title: 'Page views by country',
        description:
          'The number of people logged in to Facebook who have viewed your Page profile, broken down by Country.',
        data: getDataForLabels(countryLabels, 1, 6),
      },
      {
        name: 'device',
        title: 'Page views by Device',
        description:
          'The number of people logged in to Facebook who have viewed your Page profile, broken down by device type.',
        data: getDataForLabels(deviceLabels, 1, 15),
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.dashboard {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.metric-item {
  margin: 10px;
}
</style>





// WEBPACK FOOTER //
// PageViewsDashboard.vue?2e174ab6